module.exports = "https://cdn.realtymogul.com/static/media/carousel-arrow-small-right.e9e114b2.svg";